import React, { FC } from "react";
import { Outlet } from "react-router-dom";
import styles from "./AppLayout.module.css";
import Header from "../Header/Header";
import NavBar from "../NavBar/NavBar";
import { useAuthStore } from "src/features/auth";
import { PushBanner, PushRegistrar } from "../../../features/push-notifications";
import clsx from "clsx";
import { hasOnlyRole } from "@myapp/contract";

const AppLayout: FC = () => {
  const { user } = useAuthStore()
  const isWorker = hasOnlyRole(user?.roles ?? [], 'WORKER')
  return (
    <div className={styles.page}>
      <Header />
      <div className={styles.pageRow}>
        <NavBar />
        <div className={clsx(styles.main, 'AppLayout', isWorker && styles.workerMain)}>
          {/* Headless: re-registers this device for push on every app open, never prompts. */}
          <PushRegistrar />
          {/* The one banner: notifications. Installing is optional and deliberately lives
              only behind "App installieren" in the burger menu. */}
          <PushBanner />
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default AppLayout;